import React from 'react';
import { ContentText, FooterContainer, FooterContent } from './styled';
import { BottomPhoneButton } from '../../BottomPhoneButton';
import { PhoneButtonClickHandler } from '../../BottomPhoneButton/types';

interface ResidenceGalleryFooterProps {
  galleryDescription: string;
  priceInfo: string;
  showPhoneButton?: boolean;
  phones?: string[] | null;
  onClickHandler?: PhoneButtonClickHandler;
}

export const ResidenceGalleryFooter: React.FC<ResidenceGalleryFooterProps> = ({
  galleryDescription,
  priceInfo,
  showPhoneButton = true,
  phones,
  onClickHandler
}) => {
  return (
    <FooterContainer>
      <FooterContent>
        <ContentText tag="title_3_new">{galleryDescription}</ContentText>
        <ContentText tag="title_3_new">{priceInfo}</ContentText>
      </FooterContent>

      {showPhoneButton && onClickHandler && (
        <BottomPhoneButton
          stat="product-call-btn"
          isGallery
          isIconButton
          phones={phones}
          clickHandler={onClickHandler}
        />
      )}
    </FooterContainer>
  );
};
